import React, { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import { UserAddOutlined, CheckOutlined } from '@ant-design/icons';
import api from '../../services/api';

const BRAND = '#25D366';

// Botão de seguir/deixar de seguir player ou team.
// Se nao tiver token, click leva pro login. Se tiver, alterna estado.
// Props: targetType='player'|'team', targetId, size='small'|'default'|'large'
export default function FollowButton({ targetType, targetId, size = 'default', onChange, style }) {
  const [state, setState] = useState({ followers: 0, is_following: false, loading: true });
  const [busy, setBusy] = useState(false);
  const token = typeof window !== 'undefined' && localStorage.getItem('community_token');

  useEffect(() => {
    if (!targetType || !targetId) return;
    api.get(`/community/follows/state/${targetType}/${targetId}`)
      .then(r => setState({ ...r.data, loading: false }))
      .catch(() => setState({ followers: 0, is_following: false, loading: false }));
  }, [targetType, targetId]);

  const toggle = async () => {
    if (!token) { window.location.href = '/player/login'; return; }
    setBusy(true);
    try {
      if (state.is_following) {
        await api.delete(`/community/follows/${targetType}/${targetId}`);
        const next = { ...state, is_following: false, followers: Math.max(0, state.followers - 1) };
        setState(next); onChange?.(next);
      } else {
        await api.post('/community/follows', { target_type: targetType, target_id: targetId });
        const next = { ...state, is_following: true, followers: state.followers + 1 };
        setState(next); onChange?.(next);
        message.success('Seguindo!', 1);
      }
    } catch (err) {
      message.error(err?.response?.data?.message || 'Erro');
    } finally { setBusy(false); }
  };

  if (state.loading) return null;

  const following = state.is_following;
  return (
    <Button
      size={size} loading={busy} onClick={toggle}
      icon={following ? <CheckOutlined /> : <UserAddOutlined />}
      style={{
        borderRadius: 10, fontWeight: 700,
        background: following ? 'rgba(255,255,255,0.9)' : BRAND,
        color: following ? '#075E54' : '#fff',
        border: following ? '1px solid #075E54' : 'none',
        ...style,
      }}>
      {following ? 'Seguindo' : 'Seguir'}
      {state.followers > 0 && (
        <span style={{ marginLeft: 6, opacity: 0.75, fontSize: 12 }}>· {state.followers}</span>
      )}
    </Button>
  );
}
